import { useShow, IResourceComponentsProps, useNavigation, useGetIdentity } from '@pankod/refine-core'
import { IPaperRequest } from 'interfaces'
import metaData from 'metadata/paperRequests'
import { PaperRequestShowHeader } from './showPageheader'
import { Papers } from './showPapers'
import { useState, useEffect } from 'react'

import { useUserContext } from 'context/user'
import Permissions from 'permissions'
import { CheckUserAccess } from 'components/accessability'
import { ErrorComponent } from '@pankod/refine-antd'

type Permission = {
  granted?: boolean
}

export const PaperRequestShow: React.FC<IResourceComponentsProps> = () => {
  const { push } = useNavigation()
  const { data: user } = useGetIdentity()
  const { queryResult } = useShow<IPaperRequest>({
    resource: 'paper_requests',
    metaData: metaData,
    queryOptions: { staleTime: Infinity },
  })
  const { data: showQueryResult } = queryResult
  const record = showQueryResult?.data

  const { userRole } = useUserContext()
  const [readPermission, setReadPermission] = useState<Permission>({})
  const [createPermission, setCreatePermission] = useState<Permission>({})
  const [editPermission, setEditPermission] = useState<Permission>({})
  const [deletePermission, setDeletePermission] = useState<Permission>({})
  const [errorCode, setErrorCode] = useState<number>(200)
  useEffect(() => {
    if (userRole !== undefined) {
      setReadPermission(Permissions.can(userRole).readAny('paper_requests'))
      setCreatePermission(Permissions.can(userRole).createAny('paper_requests'))
      setEditPermission(Permissions.can(userRole).updateAny('paper_requests'))
      setDeletePermission(Permissions.can(userRole).deleteAny('paper_requests'))
    }
  }, [userRole])

  useEffect(() => {
    if (!readPermission?.granted && readPermission?.granted !== undefined) push('/')
    console.log(readPermission, 'readpermission')
  }, [readPermission])

  useEffect(() => {
    const code: any = CheckUserAccess('paper_requests', 'show', user?.id, record, userRole)
    setErrorCode(code)
  }, [userRole, user?.id, record])

  return errorCode === 200 ? (
    <>
      <PaperRequestShowHeader record={record} />
      <Papers request={record} />
    </>
  ) : (
    <ErrorComponent />
  )
}
